import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: 24px 40px;

    @media(max-width: ${theme.v2.breakpoints.md}) {
      padding: 0;
    }
  `};
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.regular};
    margin-top: 36px;
    text-align: left;
  `}
`;

export const SkeletonList = styled.div`
  ${({ theme }) => css`
    gap: 16px 24px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    margin: 24px 0;
    padding-bottom: 48px;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media(max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(2, 1fr);
      margin: 24px;
    }

    @media(max-width: ${theme.v2.breakpoints.sm}) {
      grid-template-columns: repeat(1, 1fr);
      margin: 16px;
    }
  `};
`;
